/* eslint-disable */
!function (a) {
    "use strict";
    a.extend(!0, a.trumbowyg, {
        langs: {
            en: {fontFamily: "Font"},
            es: {fontFamily: "Fuente"},
            da: {fontFamily: "Skrifttype"},
            de: {fontFamily: "Schriftart"},
            et: {fontFamily: "Font"},
            fr: {fontFamily: "Police"},
            hu: {fontFamily: "Betűtípus"},
            ko: {fontFamily: "글꼴"},
            nl: {fontFamily: "Lettertype"},
            pt_br: {fontFamily: "Fonte"},
            tr: {fontFamily: "Yazı tipi"},
            zh_tw: {fontFamily: "字體"}
        }
    });
    var n = {
        fontList: [{name: "Arial", family: "Arial, Helvetica, sans-serif"}, {
            name: "Arial Black",
            family: "Arial Black, Gadget, sans-serif"
        }, {name: "Comic Sans", family: "Comic Sans MS, Textile, cursive, sans-serif"}, {
            name: "Courier New",
            family: "Courier New, Courier, monospace"
        }, {name: "Georgia", family: "Georgia, serif"}, {
            name: "Impact",
            family: "Impact, Charcoal, sans-serif"
        }, {name: "Lucida Console", family: "Lucida Console, Monaco, monospace"}, {
            name: "Lucida Sans",
            family: "Lucida Sans Uncide, Lucida Grande, sans-serif"
        }, {name: "Palatino", family: "Palatino Linotype, Book Antiqua, Palatino, serif"}, {
            name: "Tahoma",
            family: "Tahoma, Geneva, sans-serif"
        }, {name: "Times New Roman", family: "Times New Roman, Times, serif"}, {
            name: "Trebuchet",
            family: "Trebuchet MS, Helvetica, sans-serif"
        }, {name: "Verdana", family: "Verdana, Geneva, sans-serif"}]
    };

    function i(n) {
        var i = [];
        return a.each(n.o.plugins.fontfamily.fontList, (function (a, e) {
            n.addBtnDef("fontfamily_" + a, {
                title: '<span style="font-family: ' + e.family + ';">' + e.name + "</span>",
                hasIcon: !1,
                fn: function () {
                    n.execCmd("fontName", e.family, !0)
                }
            }), i.push("fontfamily_" + a)
        })), i
    }

    a.extend(!0, a.trumbowyg, {
        plugins: {
            fontfamily: {
                init: function (e) {
                    e.o.plugins.fontfamily = a.extend({}, n, e.o.plugins.fontfamily || {}), e.addBtnDef("fontfamily", {
                        dropdown: i(e),
                        hasIcon: !1,
                        text: e.lang.fontFamily
                    })
                }
            }
        }
    })
}(jQuery);
